import request from '../../utils/request'
import server from './config'

export default {
    // 患者端 for 常见问题列表
    commonProblemPageList:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/CommonProblem/1/commonProblemPageList`,
            method: 'post',
            data,
        })
    },
    // 获取常见问题标签
    getCommonProblemLabelPageList:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/CommonProblem/1/getCommonProblemLabelPageList`,
            method: 'post',
            data,
        })
    },
    // 患者端 for 常见问题详情
    patientCommonProblemGetDetailById:(data)=>{
        return request({
            url:`${server.MS_PATIENT_CONSUMMER}/CommonProblem/1/patientCommonProblemGetDetailById`,
            method: 'post',
            data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/modules/faq.js